// Citation urls come from the SI Agent's data part, i.e. from outside this app, and end up in an
// anchor's href. `javascript:` and `data:` urls execute on click, so only absolute http(s) urls are
// ever accepted — anything else (other schemes, relative strings, unparseable input) is dropped.
const SAFE_DOC_SOURCE_PROTOCOLS = ["http:", "https:"];

export function isSafeDocSourceUrl(url: unknown): url is string {
  if (typeof url !== "string" || url.length === 0) return false;
  try {
    return SAFE_DOC_SOURCE_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    // not an absolute url — treat as unsafe rather than letting the browser resolve it
    return false;
  }
}
